import { cn } from '@/design/utils/cn';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
}

export const Section = ({ children, className }: SectionProps) => {
  return (
    <section className={cn('py-12 md:py-20', className)}>
      {children}
    </section>
  );
};
